import {Client} from 'boardgame.io/react';
import {Local} from 'boardgame.io/multiplayer';
import React from 'react';
import {MCTSBot, RandomBot} from 'boardgame.io/ai';
import {useParams} from 'react-router-dom';
import * as qs from 'qs';
import CardChessBoard from './CardChessBoard';
import {BattleCardGameRule, setupMethod} from './GameRule';

const TempGameRule = { ...BattleCardGameRule };

// 改名（临时在这改改）
TempGameRule.setup = (ctx) => {
  const setupResult = setupMethod(ctx);
  const names = ['玩家', '机器人'];
  setupResult.players = setupResult.players.map((player, idx) => {
    return {
      ...player, info: {
        ...player.info,
        name: `${names[Math.min(1, idx)]}${idx + 1}`,
      }
    }
  });
  return setupResult;
};


// const TicTacToeClient = Client({
//   TempGameRule,
//   board: CardChessBoard,
//   multiplayer: Local({ bots: { 1: MCTSBot } }),
// });
class MCBot extends MCTSBot {
  constructor({
                enumerate,
                seed,
                objectives,
                game,
                // iterations,
                // playoutDepth,
                iterationCallback,
              }) {
    const iterations = 10; // 新版bot好像很卡，这里改低点
    const playoutDepth = 200;

    // objectives是目标，目前让它playout深度高一点，自动会把胜利当目标。因为目前要看手牌数、属性、血量之类的，都不好当目标；

    super({
      enumerate, seed, objectives, iterations, playoutDepth, game, iterationCallback,
    });
  }
}

const VsAiApp = (props) => {
  const { search } = props.location;
  const params = qs.parse(search, { ignoreQueryPrefix: true });
  const { smart = '1', number = '1' } = params || {};
  const botNumber = parseInt(number, 10);
  const bot = smart !== '0' ? MCBot : RandomBot;
  const bots = {};
  Array(botNumber).fill(0).forEach((one, idx) => {
    bots[idx + 1] = bot;
  });

  console.log('VsAiApp params', params, search, bots);

  const TicTacToeClient = Client({
    game: TempGameRule,
    board: CardChessBoard,
    multiplayer: Local({
      bots
    }),
    numPlayers: botNumber + 1,
  });

  return (
    <div>
      <TicTacToeClient playerID="0"/>
    </div>
  );
};

export default VsAiApp;
